import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { RootState } from "../../../redux/store"
import {
  Vehicle,
  selectVehicle,
} from "../../../redux/slices/newReservationSlice"
import "./VehiclesList.scss"
import TimeBar from "../../Timebar/Timebar.component"

const VehiclesList: React.FC = () => {
  const dispatch = useDispatch()
  const vehicles = useSelector(
    (state: RootState) => state.newReservation.vehicles,
  )
  const selectedVehicle = useSelector(
    (state: RootState) => state.newReservation.selectedVehicle,
  )

  const handleVehicleSelect = (id: string) => {
    dispatch(selectVehicle(id))
  }

  return (
    <div className="vehicles-list-container">
      {vehicles.map((vehicle: Vehicle) => (
        <div
          key={vehicle.id}
          className={`vehicle-item full ${
            selectedVehicle === vehicle.id ? "selected" : ""
          }`}
          onClick={() => handleVehicleSelect(vehicle.id)}
        >
          <img
            src={vehicle.image}
            alt={vehicle.name}
            className="vehicle-image"
          />
          <div className="vehicle-details">
            <p className="vehicle-name">{vehicle.name}</p>
            {/* Additional details can be added here */}
          </div>
          {/* The TimeBar can be a component or an element within each vehicle item */}
          <TimeBar />
        </div>
      ))}
      {/* The TimeBar could also be a standalone component if it is independent of the vehicles */}
    </div>
  )
}

export default VehiclesList
